import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <undefined><div {...{
        "className": "crusadesupdate"
      }}>{`
    `}<h1 parentName="div" {...{
          "className": "screen-reader-text"
        }}>{`International Crusades Update`}</h1>{`
    `}<h2 parentName="div" {...{
          "className": "screen-reader-text"
        }}>{`Your prayers and gifts in action`}</h2>{`
      `}<div parentName="div" {...{
          "className": "image-float-left-fg franklin-img"
        }}>{`
            `}<img parentName="div" {...{
            "src": "https://static.billygraham.org/sites/lp.billygraham.org/uploads/prod/2025/04/wg_nc-prayer_250102_tp1_6614_960.jpg",
            "alt": ""
          }}></img>{`
    `}</div>{`
    `}<h2 parentName="div">{`DEAR FRIEND,`}</h2>{`
    `}<p parentName="div"><strong parentName="p">{`Looking back over the past several months, we’ve seen God at work around the world.`}</strong>{`Your partnership makes it all possible, and we’re incredibly thankful for your prayers and support.`}</p>{`
    `}<p parentName="div">{`My father, Franklin, and I have traveled across the globe—`}<strong parentName="p">{`from Asia to Africa to the United States—`}</strong>{`proclaiming the Gospel. Thousands have responded by placing their eternities into the loving hands of Jesus Christ. Moreover, the churches in these areas have been strengthened and emboldened in their mission to “`}<em parentName="p">{`make disciples of all the nations`}</em>{`” (Matthew 28:19, NKJV).`}</p>{`
    `}<p parentName="div">{`As I write, I’ve just finished preaching in `}<strong parentName="p">{`Fountain Hills, Arizona,`}</strong>{` and `}<strong parentName="p">{`Cochabamba, Bolivia.`}</strong>{` We praise God that between these two outreaches, thousands told us they made decisions for Jesus Christ. Later this year, I’ll be in `}<strong parentName="p">{`Canada, Estonia, and back in the United States.`}</strong>{` My father—who just wrapped up an incredible evangelistic event in Ethiopia—will proclaim the Gospel in the `}<strong parentName="p">{`United Kingdom, Belgium, and Argentina.`}</strong>{` We give God all the glory for each of these opportunities to share His truth.`}</p>{`
     `}<span parentName="div" {...{
          "className": "image-float-right"
        }}>{`
        `}<img parentName="span" {...{
            "src": "https://static.billygraham.org/sites/lp.billygraham.org/uploads/prod/2025/04/fg_ethiopia-250302_2sc6123_960.jpg",
            "alt": ""
          }}></img>{`
    `}</span>{`
    `}<p parentName="div">{`As you read these exciting updates, will you join me in thanking God for His faithfulness? `}<strong parentName="p">{`Pray for those who responded to “`}<em parentName="strong">{`the hope of glory`}</em>{`” (Colossians 1:27, NKJV) at past events, and for all who will hear the Good News in the coming months.`}</strong></p>{`
    `}<p parentName="div" {...{
          "className": "no-indent"
        }}>{`God bless you,`}</p>{`
     `}<img parentName="div" {...{
          "className": "signature",
          "src": "https://static.billygraham.org/sites/billygraham.org/uploads/prod/2022/02/Will-Graham-Signature.png",
          "alt": ""
        }}></img>{`
     `}<p parentName="div" {...{
          "className": "no-indent"
        }}>{`Will Graham  | Executive Vice President`}</p>{`
     `}<p parentName="div" {...{
          "className": "footnote no-indent"
        }}>{`*Names and photos changed to protect privacy`}</p>
      </div>
      <div {...{
        "className": "topic-one",
        "id": "he-discovered-lasting-purpose"
      }}>{`
    `}<h2 parentName="div">{`ADDIS ABABA, ETHIOPIA`}</h2>{`
    `}<h3 parentName="div">{`He Discovered Lasting Purpose`}</h3>{`
    `}<p parentName="div">{`Abat* felt adrift in life—without purpose—when `}<strong parentName="p">{`he heard about Franklin Graham’s outreach in Addis Ababa on social media.`}</strong>{` He was curious and decided to go listen to what Franklin had to say. When Abat heard that “`}<em parentName="p">{`God so loved the world, that he gave his only Son, that whoever believes in him should not perish but have eternal life`}</em>{`” (John 3:16, ESV), he was filled with joy—and began to understand his life’s true meaning. He prayed to place his faith and trust in Jesus Christ. Afterward, `}<strong parentName="p">{`he told us that his feelings of fear, hopelessness, and confusion have been replaced with happiness.`}</strong>{` Will you pray for him as he learns to follow the Lord?`}</p>
      </div>
      <div {...{
        "className": "topic-two",
        "id": "from-overwhelming-fear-to-joyful-freedom"
      }}>{`
    `}<h2 parentName="div">{`ADDIS ABABA, ETHIOPIA`}</h2>{`
    `}<h3 parentName="div">{`From Overwhelming Fear to Joyful Freedom`}</h3>{`
    `}<p parentName="div">{`Ekender* attended the Franklin Graham event in Addis Ababa. He was weighed down with fear and anxiety—and was in the midst of what he called spiritual warfare. When Franklin shared the Gospel, `}<strong parentName="p">{`Ekender’s eyes opened to the truth,`}</strong>{` and he wanted to give his life to
     “`}<em parentName="p">{`the God of peace who brought again from the dead our Lord Jesus`}</em>{`” (Hebrews 13:20, ESV).
      `}<span parentName="p" {...{
            "className": "image-float-right"
          }}>{`
        `}<img parentName="span" {...{
              "src": "https://static.billygraham.org/sites/lp.billygraham.org/uploads/prod/2025/04/250302_mr1_104.jpg",
              "alt": ""
            }}></img>{`
    `}</span>{`
      At the invitation, Ekender prayed to receive Christ in repentance and faith. After, he shared that he had felt afraid all the time—but now, he was filled with happiness and peace. `}<strong parentName="p">{`Counselors connected Ekender with leaders at a local church, who will disciple him and help him leave behind the lifestyle that had left him mired in overwhelming fear.
    `}</strong>{` Please pray for him as he embraces new life in Jesus Christ.`}</p>
      </div>
      <div {...{
        "className": "topic-two",
        "id": "i-feel-free-today"
      }}>{`
    `}<h2 parentName="div">{`FOUNTAIN HILLS, ARIZONA`}</h2>{`
    `}<h3 parentName="div">{`‘I Feel Free Today …’`}</h3>{`
     `}<span parentName="div" {...{
          "className": "image-float-right"
        }}>{`
        `}<img parentName="span" {...{
            "src": "https://static.billygraham.org/sites/lp.billygraham.org/uploads/prod/2025/04/fhills_hispanic_250301_sm1_6902_960.jpg",
            "alt": ""
          }}></img>{`
    `}</span>{`
    `}<p parentName="div">{`Diego* was among the thousands of people who listened to Will Graham share the Good News 
    of Jesus Christ in Fountain Hills, Arizona, just northeast of Phoenix. The 35-year-old followed along intently as Will told the crowd, “A Creator gives purpose to His creation. Our purpose 
    in life is to have a relationship with God.” `}<strong parentName="p">{`Tears filled Diego’s eyes as he realized how lost he really was—and how ready he was to find freedom from his addiction to alcohol.`}</strong>{` When Will gave the invitation, Diego walked forward to repent of his sins and place his faith in Jesus Christ. He connected with Gabriel, a local pastor serving as a prayer volunteer at the Celebration. After the two talked and prayed together, Diego said, “I feel free today.” We praise God that he responded to the promise that “`}<em parentName="p">{`the wages of sin is death, but the free gift of God is eternal life in Christ Jesus our Lord`}</em>{`” (Romans 6:23, ESV).
    `}</p>{`
       `}<span parentName="div" {...{
          "className": "image-center image-two"
        }}>{`
        `}<img parentName="span" {...{
            "src": "https://static.billygraham.org/sites/lp.billygraham.org/uploads/prod/2025/04/250401_lr2_9567-enhanced-nr_1920.jpg",
            "alt": ""
          }}></img>{`
        `}<figcaption parentName="span"><span parentName="figcaption" {...{
              "className": "number2"
            }}>{`COCHABAMBA, BOLIVIA:`}</span>{` Will Graham boldly proclaimed the Good News of Jesus Christ in Cochabamba, Bolivia, the country’s agricultural center and third-largest city.`}</figcaption>{`
    `}</span>
      </div>
      <div {...{
        "className": "topic-two",
        "id": "i-decided-to-hand-everything-over-to-god"
      }}>{`
    `}<h2 parentName="div">{`COCHABAMBA, BOLIVIA`}</h2>{`
    `}<h3 parentName="div">{`‘I Decided to Hand Everything Over to God …’`}</h3>{`
    `}<p parentName="div">{`Luis* was invited to Esperanza Cochabamba by his younger sister—but he initially resisted the idea of attending the Celebration. The 26-year-old had attended church before but never had much interest in matters of faith. When his sister insisted he join her, he finally agreed. `}<strong parentName="p">{`Despite his initial resistance, the Holy Spirit worked in Luis’ heart as Will preached.`}</strong>{` Luis was deeply touched by the promise that he could find freedom from past sins that burdened him. “I am very impressed by this Good News,” he said. “I decided to hand everything over to God, and that leads me to believe that He will bring something new into my life.” Luis explained how the Gospel changed his heart. `}<strong parentName="p">{`“I feel that I finally got it,” he said.`}</strong>{` “I understood that I am a sinner, and I wanted to repent of all my sins and start following Him.” Will you pray that Luis will grow “`}<em parentName="p">{`in all spiritual wisdom and understanding`}</em>{`” (Colossians 1:9, ESV)?`}</p>
      </div>
      <div {...{
        "className": "topic-two",
        "id": "if-i-am-not-in-this-world-anymore"
      }}>{`
    `}<h2 parentName="div">{`VIENTIANE, LAOS`}</h2>{`
    `}<h3 parentName="div">{`‘If I Am Not in This World Anymore …’`}</h3>{`
    `}<p parentName="div">{`The two-day Christmas of Love Festival in Vientiane, Laos, marked the first time that Christians in the country had the opportunity to come together for such an event. “`}<strong parentName="p">{`There is an explosion of blessing from God that happened in Laos,`}</strong>{`” said Rev. Sichanh Keosavang, a senior pastor there. “All of this happened not because of our strength but because of God’s leading. I’m thinking about how we will lead the new believers who received Christ at the event.” His church, which typically sees an attendance of about 75 people on most Sundays, received the names of more than 80 new believers to follow up with as a result of the meetings. 
    `}<span parentName="p" {...{
            "className": "image-float-right"
          }}>{`
        `}<img parentName="span" {...{
              "src": "https://static.billygraham.org/sites/lp.billygraham.org/uploads/prod/2025/04/241202_sc1_0436_960.jpg",
              "alt": ""
            }}></img>{`
    `}</span>{`
    Rith* is among hundreds referred to Laotian pastors across the region for follow up. He had traveled 90 minutes with his wife to attend the Festival. `}<strong parentName="p">{`When Franklin preached the Gospel, Rith was deeply touched.`}</strong>{` He said a prayer of “`}<em parentName="p">{`repentance toward God and of faith in our Lord Jesus Christ`}</em>{`” (Acts 20:21, ESV). “If I am not in this world anymore, I will be with God,” Rith rejoiced.`}</p>
      </div>
      <br></br>{`
 `}<div {...{
        "className": "image-center image-one"
      }}>{`
        `}<img parentName="div" {...{
          "src": "https://static.billygraham.org/sites/lp.billygraham.org/uploads/prod/2025/04/241201_dji_0157_1920.jpg",
          "alt": ""
        }}></img>{`
        `}<figcaption parentName="div" {...{
          "className": "number1"
        }}><span parentName="figcaption" {...{
            "className": "number2"
          }}>{`CAN THO, VIETNAM:`}</span>{`
        Men, women, and children from all over the region heard Franklin Graham share the Gospel in Can Tho, Vietnam—and hundreds responded by placing their faith in Jesus Christ.
        `}</figcaption>{`
    `}</div>
      <div {...{
        "className": "topic-two",
        "id": "i-have-god-in-me"
      }}>{`
    `}<h2 parentName="div">{`CAN THO, VIETNAM`}</h2>{`
    `}<h3 parentName="div">{`‘I Have … God in Me’`}</h3>{`
    `}<div parentName="div" {...{
          "className": "image-float-right"
        }}>{`
        `}<img parentName="div" {...{
            "src": "https://static.billygraham.org/sites/lp.billygraham.org/uploads/prod/2025/04/241201_lr2_0551_960.jpg",
            "alt": ""
          }}></img>{`
    `}</div>{`
    `}<p parentName="div">{`For months before Franklin Graham’s Can Tho Season of Love Festival, the Holy Spirit was working in Tai’s* heart. The young man heard about Jesus Christ at school as he learned about the Western world. `}<strong parentName="p">{`Fascinated, he had begun reading the Bible online—but did not fully understand the Gospel`}</strong>{`. Tai attended the Festival and listened closely as Franklin shared the Good News that “`}<em parentName="p">{`God did not send his Son into the world to condemn the world, but in order that the world might be saved through him`}</em>{`” (John 3:17, ESV). When Franklin gave the invitation, Tai responded by praying to surrender his life to the Lord. `}<strong parentName="p">{`“God is the God of the universe,” he said. “Now, I feel like I have that God in me.”`}</strong>{` We praise the Lord for this changed life! `}</p>
      </div>
      <div>
        <section parentName="div" {...{
          "className": "how-to-help topic-one",
          "id": "crusades-how-to-help"
        }}>{`
    `}<h3 parentName="section" {...{
            "className": "h3-portion"
          }}>{`Crusades `}<span parentName="h3" {...{
              "className": "steps"
            }}></span><span parentName="h3" {...{
              "className": "smallportion"
            }}>{` How you can help`}</span></h3>{`
    `}<p parentName="section" {...{
            "className": "no-indent"
          }}><strong parentName="p"><em parentName="strong">{`God works through people like you to change the world by the power of the Gospel.`}</em></strong></p>{`
    `}<p parentName="section" {...{
            "className": "no-indent"
          }}><span parentName="p" {...{
              "className": "step"
            }}>{`PRAY: `}</span>{`You are a part of the life-changing work of Gospel proclamation through your prayers. Please ask God to draw people to Himself in each area where we hold Festival and Celebration events.`}</p>{`
    `}<p parentName="section" {...{
            "className": "no-indent"
          }}><span parentName="p" {...{
              "className": "step"
            }}>{`GIVE: `}</span>{`It is only through the generosity of friends like you that we can continue reaching people far from God with the Good News of Jesus Christ. Your support helps share life-changing hope with spiritually hungry people across the globe.`}</p>
        </section>
        <br parentName="div"></br>
      </div></undefined>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      